"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BorderBox = void 0;

var _styledComponents = require("styled-components");

var _helpers = require("../../helpers");

var _primitives = require("../../platform/primitives");

var _BorderBoxBase = require("./BorderBoxBase");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/**
 * A `div` that has a common border and padding set by default, with an optional
 * `hover` property for visually focusing content.
 */
var BorderBox = (0, _primitives.styledWrapper)(_BorderBoxBase.BorderBoxBase)(_templateObject(), function (_ref) {
  var hover = _ref.hover;
  return hover && (0, _styledComponents.css)([":hover{border-color:", ";}"], (0, _helpers.color)("black60"));
});
exports.BorderBox = BorderBox;
BorderBox.displayName = "BorderBox";
//# sourceMappingURL=BorderBox.js.map